import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseSearchDropDownNew = (url, search) => {
    const [data, setData] = useState([]);

    async function getData() {
        axiosInstance.get(url, { params: { search: search } }).then(res => {
            let resData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
            let tempData = [];
            resData.forEach((item) => {
                let tempObject = { value: item.id, label: item.name || item.ref || item.id };
                tempData.push(tempObject);
            });
            setData(tempData);
        }).catch(err => {
            console.log(err, "err");
        })
    }

    useEffect(() => {
        getData();
    }, [url, search]);

    return { data, setData };
};

export default UseSearchDropDownNew